import { apiErrorHandler } from '../errorHandler'

export async function deleteProject(projectId: number): Promise<void> {
  const res = await fetch(`/api/projects/${projectId}`, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' }
  })
  await apiErrorHandler(res)
}
